import React, { useState, useEffect  } from "react";
import { useNavigate } from "react-router-dom";
import { sendOtpApi, verifyOtpApi, resetPasswordApi } from "../service/forgotpasswordService.js";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../Admin/css/forgot.css";
import { getCompanyUrl } from "../utils/getCompanyUrl.js";

const ForgotPassword = () => {
const [step, setStep] = useState(1);
const [scholarId, setScholarId] = useState("");
const [email, setEmail] = useState("");
const [otp, setOtp] = useState("");
const [newPassword, setNewPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [message, setMessage] = useState("");
const navigate = useNavigate();
const [timer, setTimer] = useState(300); // 5 mins = 300 sec
const [isExpired, setIsExpired] = useState(false);
const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

useEffect(() => {
  if (step === 2 && timer > 0) {
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }

  if (timer === 0) {
    setIsExpired(true);
  }
}, [timer, step]);

const formatTime = (sec) => {
  const minutes = Math.floor(sec / 60);
  const seconds = sec % 60;
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

 

  const sendOtp = async (e) => {
  e.preventDefault();

  try {
    const payload = {
      user_id: scholarId,
      email: email,
        //com_url_code:"http://maathangischolar.seasense.in/",
      com_url_code:getCompanyUrl(),
    };

  const res = await sendOtpApi(payload);
    // await forgotPassword(payload);

    setMessage(res.data?.message || "OTP sent successfully ✅");
     // Hide message after 3 seconds
    setTimeout(() => {
      setMessage("");
    }, 3000);

    setStep(2);
setTimer(300);
setIsExpired(false);

  } catch (err) {
    console.error(err);
    setMessage(err.response?.data?.message || "Failed to send OTP ❌");
     // Hide error message after 3 seconds
    setTimeout(() => {
      setMessage("");
    }, 3000);

     // Hide error message after 3 seconds
    setTimeout(() => {
      setMessage("");
    }, 3000);
  }
};



const verifyOtp = async (e) => {
  e.preventDefault();
     if (otp.length !== 6) {
    setMessage("Enter valid 6-digit OTP ❌");
    return;
  }
  try {
    const payload = {
      otp: otp,
      user_id: scholarId,
    };

    
  const res = await verifyOtpApi(payload);
   // ✅ handle different success formats
    const isSuccess =
      res.data?.status === "success" ||
      res.data?.status === true ||
      res.data?.success === true;

    if (isSuccess) {
      setMessage("OTP verified ✅");
      // Hide message after 3 seconds
    setTimeout(() => {
      setMessage("");
    }, 3000);

      setStep(3); // ✅ go to reset password
    } else {
      setMessage( "Invalid OTP ❌");
      // Hide error message after 3 seconds
    setTimeout(() => {
      setMessage("");
    }, 3000);
    }
    
  } catch (err) {

    setMessage("Invalid OTP ❌");
    // Hide error message after 3 seconds
    setTimeout(() => {
      setMessage("");
    }, 3000);
  }
};



const resetPassword = async (e) => {
  e.preventDefault();

  if (newPassword !== confirmPassword) {
    setMessage("Passwords do not match ❌");
    return;
  }

    try {
    const payload = {
      user_id: scholarId,
      new_pwd: newPassword,
      confirm_pwd: confirmPassword,
    };

    const res = await resetPasswordApi(payload);

    setMessage(res.data?.message || "Password reset successful ✅");

    setTimeout(() => {
      navigate("/", { replace: true });
    }, 1500);

  } catch (err) {
    console.error(err);
    setMessage(err.response?.data?.message || "Reset failed ❌");
     // Hide error message after 3 seconds
    setTimeout(() => {
      setMessage("");
    }, 3000);
  }
};

const resendOtp = async () => {
  try {
    const payload = {
      user_id: scholarId,
      email: email,
      com_url_code: getCompanyUrl(),
    };

    const res = await sendOtpApi(payload);

    setMessage(res.data?.message || "OTP resent ✅");

    // restart timer
    setTimer(300);
    setIsExpired(false);

  } catch (err) {
    setMessage("Failed to resend OTP ❌");
  }
};


  return (
    <div className="login-wrapper">
      <div className="login-right">
        <div className="login-box">
          <h2>Forgot Password</h2>
         <p className="sub-text">
  {step === 1 &&
    "Enter your Scholar ID and registered email address to receive an OTP"}
  {step === 2 &&
    "Enter the OTP sent to your registered email address"}
  {step === 3 &&
    "Create a new password for your account"}
</p>

       {step === 1 && (
  <form onSubmit={sendOtp}>
    <input
      type="text"
      placeholder="Scholar ID"
      value={scholarId}
      onChange={(e) => setScholarId(e.target.value)}
      required
    />

    <input
      type="email"
      placeholder="Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required
    />

    <button type="submit">Send OTP</button>
  </form>
)}

{step === 2 && (
  <form>
    <input
      type="text"
      placeholder="Enter 6-digit OTP"
      value={otp}
    onChange={(e) => {
  const value = e.target.value.replace(/\D/g, "");
  setOtp(value);
  setMessage("");
}}
      maxLength={6}
      required
    />

    {/* ⏱ Timer */}
    {!isExpired && (
      <p style={{ color: "gray", marginBottom: "10px" }}>
        OTP expires in: {formatTime(timer)}
      </p>
    )}

    {/* 🔁 Resend Button */}
    {isExpired && (
      <button
        type="button"
        onClick={resendOtp}
        style={{ marginBottom: "10px", background: "#888" }}
      >
        Resend OTP
      </button>
    )}

   <button
  type="button"
  onClick={verifyOtp}
  disabled={otp.length !== 6}
>
  Verify OTP
</button>
  </form>
)}

{step === 3 && (
  <form onSubmit={resetPassword}>
     <div
                style={{
                  position: "relative",
                  marginBottom: "15px",
                }}
              >
    <input
      type={showNewPassword ? "text" : "password"}
      placeholder="New Password"
      value={newPassword}
      onChange={(e) => setNewPassword(e.target.value)}
      required
       style={{ width: "100%", paddingRight: "45px" }}
    />
    <span
                  onClick={() =>
                    setShowNewPassword(!showNewPassword)
                  }
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showNewPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
                </div>
                 <div
                style={{
                  position: "relative",
                  marginBottom: "15px",
                }}
              >

    <input
      type={showConfirmPassword ? "text" : "password"}
      placeholder="Confirm Password"
      value={confirmPassword}
      onChange={(e) => setConfirmPassword(e.target.value)}
      required
       style={{ width: "100%", paddingRight: "45px" }}
    />
     <span
                  onClick={() =>
                    setShowConfirmPassword(!showConfirmPassword)
                  }
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showConfirmPassword ? (
                    <FaEye />
                  ) : (
                    <FaEyeSlash />
                  )}
                </span>
</div>
    <button type="submit">Reset Password</button>
  </form>
)}

        {message && (
  <p
    className={
      message.includes("❌") || message.toLowerCase().includes("failed")
        ? "message error"
        : "message success"
    }
  >
    {message}
  </p>
)}

          <div className="extra">
            <span 
              style={{ cursor: "pointer", color: "#fff" }}
              onClick={() => navigate("/")}
            >
              Back to Login
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;